import { Type } from 'class-transformer';
import { IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { PropertyCountry, PropertyGeolocationType } from './property-enums';

export class AddressDto {
  @IsEnum(PropertyCountry)
  country!: PropertyCountry;

  @IsString()
  city!: string;

  @IsString()
  zipCode!: string;

  @IsString()
  street!: string;

  @IsOptional()
  @IsString()
  complement?: string;

  @IsOptional()
  @IsString()
  district?: string;

  @IsOptional()
  @IsString()
  houseNumber?: string;

  @IsOptional()
  @IsString()
  label?: string;

  @IsOptional()
  @IsString()
  region?: string;

  @IsOptional()
  @IsString()
  cityCode?: string;
}

export class CoordinatesDto {
  @IsNumber()
  latitude!: number;

  @IsNumber()
  longitude!: number;
}

export class PropertyLocationPoiDto {
  @IsString()
  id!: string;

  @IsString()
  name!: string;

  @IsString()
  category!: string;

  @IsNumber()
  lat!: number;

  @IsNumber()
  lng!: number;

  @IsOptional()
  @IsNumber()
  distanceMeters?: number;

  @IsOptional()
  @IsString()
  details?: string;
}

export class PropertyLocationDto {
  @ValidateNested()
  @Type(() => AddressDto)
  address: AddressDto = new AddressDto();

  @IsOptional()
  @ValidateNested()
  @Type(() => CoordinatesDto)
  coordinates?: CoordinatesDto;

  // Geolocation
  @IsEnum(PropertyGeolocationType)
  geolocationType!: PropertyGeolocationType;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => PropertyLocationPoiDto)
  pois?: PropertyLocationPoiDto[];
}
